const IFRAME_CLEANUP_MS = 60_000;

/**
 * 서버가 준 S3 서명 URL은 fetch/blob 하지 않고 브라우저 다운로드로 넘긴다.
 *
 * ZIP·엑셀 URL은 API가 끝난 뒤에 연다. 그때 `target=_blank`/`window.open` 을
 * 쓰면 클릭 스택이 끊겨 팝업 차단된다. Content-Disposition: attachment 는
 * 숨은 iframe 으로 받아도 저장되고, 현재 탭은 그대로 둔다.
 */
export const openPresignedFile = (downloadUrl: string) => {
  const url = downloadUrl.trim();
  if (!url) {
    throw new Error('다운로드 URL이 없습니다.');
  }

  const frame = document.createElement('iframe');
  frame.src = url;
  frame.setAttribute('aria-hidden', 'true');
  frame.tabIndex = -1;
  frame.style.display = 'none';
  frame.style.width = '0';
  frame.style.height = '0';
  frame.style.border = '0';
  document.body.appendChild(frame);

  window.setTimeout(() => {
    frame.remove();
  }, IFRAME_CLEANUP_MS);
};
